export default __webpack_public_path__ + "static/media/centuri.8ed016dc.png";